import React from 'react';
import classnames from 'classnames';

const className = "cursor-pointer bg-red-600 p-3 px-6 text-red-100 font-semibold rounded-full";

const DangerButton = props => (
  <button {...props} className={classnames(className, props.className)}>{props.children}</button>
);

export default DangerButton;